<template>
	<div>
		<div class="form-group form-md-line-input form-md-floating-label">
	        <input type="text" class="form-control input-sm" :class="{'edited': searchTerm}" id="google_places_search" v-model.trim="searchTerm" placeholder="">
	        <label for="google_places_search">Search for your location <small class="font-grey-cascade">(Make sure your location is set up on Google.)</small></label>
	    </div>
	    <div v-if="selectedLocation.name && confirmationMessage.length" class="margin-bottom-5 margin-left-15"><small v-html="confirmationMessage"></small></div>
	    <div v-if="selectedLocation.name" class="col-xs-12 blog-page blog-content-1">
	    	<div class="blog-post-xs bordered blog-container">
	    		<div class="blog-img-thumb">
	    			<img :src="selectedLocation.main_photo">
	    		</div>
	    		<div class="blog-post-content">
	    			<h2 class="blog-title blog-post-title"><a>{{ selectedLocation.name }}</a></h2>
	    			<p class="font-grey-mint" v-html="selectedLocation.adr_address"></p>
	    			<p class="font-grey-mint" v-if="selectedLocation.formatted_phone_number"><i class="fa fa-phone"></i> {{ selectedLocation.formatted_phone_number }}</p>
	    			<p class="font-grey-mint" v-if="selectedLocation.website"><i class="fa fa-globe"></i> <a :href="selectedLocation.website" target="_blank">{{ selectedLocation.website }}</a></p>
	    		</div>
	    	</div>
	    </div>
	</div>
</template>
<script>
import $ from 'jquery'
import GoogleMapsApiLoader from 'google-maps-api-loader'

/**
 * Google Places Search module is used to search for a Google place and retrieve the appropriate data from it.
 * @class GooglePlacesSearch
 * @prop {string} passedValue - Used to pass a predetermined search value into the api.
 * @prop {string} confirmationMessage - Used to tell the user how to proceed.
 * @prop {object} currentSelectedLocation - Used pass in the selected location if one has already been chosen.
 * @since 0.0.8
 */

export default {
	name: 'google-places-search',
	props: {
		passedValue: {
			type: String,
			default: ''
		},
		confirmationMessage: {
			type: String,
			default: ''
		},
		currentSelectedLocation: {
			type: Object
		}
	},
	data () {
		return {
			searchTerm: '',
			selectedLocation: {}
		}
	},
	/**
	 * Run on `created` to initialize the Googles Places API
	 * @function
	 * @returns {undefined}
	 * @memberof GooglePlacesSearch
	 * @version 0.0.8
	 */
	created () {
		if (this.currentSelectedLocation && this.currentSelectedLocation.id) {
			let routeName,
				city,
				province,
				country

			for (let i = 0, x = this.currentSelectedLocation.address_components.length; i < x; i++) {
				for (let j = 0, y = this.currentSelectedLocation.address_components[i].types.length; j < y; j++) {
					switch (this.currentSelectedLocation.address_components[i].types[j]) {
					case 'route':
						routeName = this.currentSelectedLocation.address_components[i].long_name
						break

					case 'locality':
						city = this.currentSelectedLocation.address_components[i].long_name
						break

					case 'administrative_area_level_1':
						province = this.currentSelectedLocation.address_components[i].short_name
						break

					case 'country':
						country = this.currentSelectedLocation.address_components[i].long_name
						break

					default:
						// No Default
					}
				}
			}
			let tempTerm = this.currentSelectedLocation.name
			if (routeName && routeName.length) {
				tempTerm += ', ' + routeName
			}
			if (city && city.length) {
				tempTerm += ', ' + city
			}
			if (province && province.length) {
				tempTerm += ', ' + province
			}
			if (country && country.length) {
				tempTerm += ', ' + country
			}
			this.searchTerm = tempTerm

			this.selectedLocation = this.currentSelectedLocation
		} else if (this.passedValue.length) {
			this.searchTerm = this.passedValue
		}

		let _this = this

		// Set Timeout is used to delay the initialization of the Autocomplete block until the transition has ended
		setTimeout(() => {
			GoogleMapsApiLoader({
				libraries: ['places'],
				apiKey: 'AIzaSyBTLgkSK3g81GRBpZATw0UmxkwlbbRXwVg'
			})
			.then(googleApi => {
				let input = document.getElementById('google_places_search')
				let autocomplete = new googleApi.maps.places.Autocomplete(input)
				autocomplete.setTypes(['establishment'])

				if ((!this.currentSelectedLocation || !this.currentSelectedLocation.id) && this.passedValue.length) {
					_this.inputFocus()
				}

				autocomplete.addListener('place_changed', () => {
					_this.searchTerm = input.value
					_this.selectedLocation = autocomplete.getPlace()
					_this.formatSelectedLocationData()
				})
			}, err => {
				console.error(err)
			})
		}, 500)
	},
	methods: {
		/**
		 * To format the data returned from Google for use in our system.
		 * @function
		 * @returns {undefined}
		 * @memberof GooglePlacesSearch
		 * @version 0.0.8
		 */
		formatSelectedLocationData () {
			if (this.selectedLocation.photos) {
				this.selectedLocation.main_photo = this.selectedLocation.photos[0].getUrl({maxWidth: 640})
			}
			this.selectedLocation.coordinates = {
				lat: this.selectedLocation.geometry.location.lat(),
				lng: this.selectedLocation.geometry.location.lng()
			}
			this.emitSelectedLocation()
		},
		/**
		 * To force focus on the input field in order to search for the passedValue
		 * @function
		 * @returns {undefined}
		 * @memberof GooglePlacesSearch
		 * @version 0.0.8
		 */
		inputFocus () {
			if ($(document).find('.pac-container').length) {
				$('#google_places_search').focus()
			} else {
				setTimeout(() => {
					this.inputFocus()
				}, 100)
			}
		},
		/**
		 * To emit that the value of the selected location has been changed
		 * @function
		 * @returns {undefined}
		 * @memberof GooglePlacesSearch
		 * @version 0.0.8
		 */
		emitSelectedLocation () {
			this.$emit('selectedLocation', this.selectedLocation)
		}
	}
}
</script>
<style>
.blog-content-1 .blog-post-xs>.blog-img-thumb {
	height: 100px;
}
</style>


// WEBPACK FOOTER //
// GooglePlacesSearch.vue?fcff8a8a